import { API_BASE_URL } from '../utils';
import './ArtistsCardEventDetail.css'
import artist2 from './image/bandimg2.jpg';



const URL = `${API_BASE_URL}/master/assets/uploads/`;

export default function ArtistsCardEventDetail({ artist }) {


    return (
        <>
            <div className='artists-card-event-detail-section'>
                <div className='Fartists-card-event-detail-eedHorizontalScroll-container'>
                    <div className='artists-card-event-detail-content'>
                        <div className='artists-card-event-detail-card'>
                            <div className='artists-card-event-detail-card-img'>
                                <img src={URL + artist?.cover_pic} alt="" />
                                <div className='artists-card-event-detail-card-img-overlay'>
                                    <p>{artist?.name}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
